<template>
  <v-tabs>
    <v-tab>Client</v-tab>
    <v-tab v-if="lead.type_id == 2">Beneficiaries</v-tab>
    <v-tab-item>
      <ClientBlock
        :lead="lead"
        :agent_id="agent.id"
        :baseData="baseData"
        v-if="source != 'mediaalpha' && lead.type_id === 2"
      />
      <ClientBlockMedialpha
        :lead="lead"
        :agent_id="agent.id"
        :baseData="baseData"
        v-else
      />
    </v-tab-item>
    <v-tab-item>
      <BeneficiaryBlock :lead_id="lead.id" :baseData="baseData" />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import ClientBlock from "./ClientBlock";
import ClientBlockMedialpha from "./ClientBlockMedialpha";
import BeneficiaryBlock from "./BeneficiaryBlock";

export default {
  name: "ClientTab",
  props: {
    baseData: Object,
    source: String,
    lead: Object,
    agent: Object,
  },
  components: {
    ClientBlock,
    ClientBlockMedialpha,
    BeneficiaryBlock,
  },
};
</script>

<style>
</style>